import { create } from 'zustand';
import contestService from '../services/contestService';

// The contest the app is currently announcing (public /active): { phase, contest, stats, rules }.
// Fetched once and shared by the menus / dashboard card / contest page (re-fetched after 60s).
// phase: live | hold | upcoming | final | inactive. `isOn` = a contest is running or about to.
const TTL_MS = 60 * 1000;
let inFlight = null;

export const useContestStore = create((set, get) => ({
    data: null,
    loadedAt: 0,
    fetchActive: async (force = false) => {
        const { loadedAt } = get();
        if (!force && Date.now() - loadedAt < TTL_MS) return get().data;
        if (inFlight) return inFlight;
        inFlight = contestService.getActiveContest()
            .then((res) => {
                const data = { phase: res?.phase || (res?.active ? 'live' : 'inactive'), contest: res?.contest || null, stats: res?.stats || null, rules: res?.rules || null };
                set({ data, loadedAt: Date.now() });
                return data;
            })
            .catch(() => { set({ loadedAt: Date.now() }); return get().data; })
            .finally(() => { inFlight = null; });
        return inFlight;
    },
}));

/** True while a contest is live, in its 1-hour hold, or switched on before it starts. */
export const isContestOn = (data) => ['live', 'pending', 'upcoming', 'completed'].includes(data?.phase);
